// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "52902f04499377f0f3b3" + "-chunk.js";
};